export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./beenCourse.vue?vue&type=template&id=7b529806&"


//////////////////
// WEBPACK FOOTER
// ./src/views/lesson/component/beenCourse.vue?vue&type=template&id=7b529806&
// module id = null
// module chunks = 